export default __webpack_public_path__ + "static/media/arrow_2.6ccec43d.svg";